import React from 'react'

const CrmTable = ({ color = '#676767' }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 0H13C12.7348 0 12.4804 0.105357 12.2929 0.292893C12.1054 0.48043 12 0.734784 12 1V7C12 7.26522 12.1054 7.51957 12.2929 7.70711C12.4804 7.89464 12.7348 8 13 8H14V10H16V8H18V10H20V1C20 0.734784 19.8946 0.48043 19.7071 0.292893C19.5196 0.105357 19.2652 0 19 0ZM16 6H14V2H18V6H16ZM1 8H7C7.26522 8 7.51957 7.89464 7.70711 7.70711C7.89464 7.51957 8 7.26522 8 7V1C8 0.734784 7.89464 0.48043 7.70711 0.292893C7.51957 0.105357 7.26522 0 7 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V7C0 7.26522 0.105357 7.51957 0.292893 7.70711C0.48043 7.89464 0.734784 8 1 8ZM2 2H6V6H2V2ZM3 14V16H1V14H3ZM1 18H3V20H1V18ZM5 16V18H3V16H5ZM5 14H3V12H5V10H7V14H5ZM3 10V12H1V10H3ZM12 13V14H11V12H9V16H12V19C12 19.2652 12.1054 19.5196 12.2929 19.7071C12.4804 19.8946 12.7348 20 13 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V13C20 12.7348 19.8946 12.4804 19.7071 12.2929C19.5196 12.1054 19.2652 12 19 12H14V10H12V13ZM18 14V18H14V14H18ZM7 16H9V18H10V20H5V18H7V16ZM11 4H9V2H11V4ZM9 6H11V10H9V6ZM3 3H5V5H3V3ZM15 3H17V5H15V3ZM17 17H15V15H17V17Z"
        fill={color}
      />
    </svg>
  )
}

export default CrmTable
